<template>
  <div id="main-wrapper pt-0" class="show">
    <Header :active="active" />

    <!-- <div class="header landing_page">
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <nav class="navbar navbar-expand-lg navbar-light px-0">
              <router-link class="navbar-brand" to="/Index"
                ><img :src="$t('head.logo')" alt="" />
                <span>OTC919</span></router-link
              >
              <b-navbar-toggle target="nav-collapse"> </b-navbar-toggle>

              <b-collapse as="div" id="nav-collapse" is-nav>
                <ul class="navbar-nav">
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      href="#intro"
                      @click="active = 'home'"
                      :class="active === 'home' && 'active'"
                      >Home</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      href="#demo"
                      @click="active = 'demo'"
                      :class="active === 'demo' && 'active'"
                      >Demo</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      href="#Support"
                      @click="active = 'support'"
                      :class="active === 'support' && 'active'"
                      >Support</a
                    >
                  </li>
                </ul>
              </b-collapse>
              <div class="dashboard_log">
                <div class="d-flex align-items-center">
                  <div class="header_auth">
                    <router-link to="/buy-sell" class="btn btn-success"
                      >Buy</router-link
                    >
                    <a
                      href="https://www.fiverr.com/quixlab"
                      class="btn btn-outline-primary"
                      target="_blank"
                      >Hire me</a
                    >
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div> -->

    <div
      class="intro section-padding position-relative"
      id="intro"
      data-scroll-index="0"
    >
      <div class="container">
        <div class="row align-items-center justify-content-between">
          <div class="col-xl-6 col-md-6">
            <div class="intro-content">
              <h2>Buy and sell <br />cryptocurrency</h2>
              <p>
                Fast and secure way to purchase or exchange 150+
                cryptocurrencies
              </p>
              <a href="#" class="btn waves-effect">GET STARTED</a>
            </div>
          </div>
          <div class="col-xl-4 col-md-6 py-md-5">
            <div class="card">
              <div class="card-body">
                <div class="buy-sell-widget">
                  <form
                    method="post"
                    name="myform"
                    class="currency_validate"
                    novalidate="novalidate"
                  >
                    <div class="mb-3">
                      <label class="form-label">Currency</label>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <label class="input-group-text"
                            ><i class="cc USDT-alt"></i
                          ></label>
                        </div>
                        <select name="currency" class="form-control">
                          <option value="">Select</option>
                          <option value="usdc" selected>USDC</option>
                          <!-- <option value="bitcoin">Bitcoin</option>
                          <option value="litecoin">Litecoin</option> -->
                        </select>
                      </div>
                    </div>

                    <div class="mb-3">
                      <label class="form-label"
                        >Payment Method
                      </label>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <label class="input-group-text py-3"
                            ><i class="fa fa-bank"></i
                          ></label>
                        </div>
                        <select class="form-control" name="method">
                          <option value="">Select</option>
                          <option
                            value="bank"
                            v-for="(item, index) in data"
                            :key="index"
                          >
                            {{ item.cardName }} {{ item.typeName }}
                            {{ item.account_no }}
                          </option>
                          <!-- <option value="master">
                            Master Card ***********5458
                          </option> -->
                        </select>
                      </div>
                    </div>

                    <div class="mb-3">
                      <label class="form-label">Enter your amount</label>
                      <div class="input-group">
                        <input
                          type="text"
                          name="currency_amount"
                          class="form-control"
                          placeholder="99 USDC"
                        />
                        <input
                          type="text"
                          name="usd_amount"
                          class="form-control"
                          placeholder="100 USD"
                        />
                      </div>
                      <div class="d-flex justify-content-between mt-3">
                        <p class="mb-0">Monthly Limit</p>
                        <h6 class="mb-0">$49750 remaining</h6>
                      </div>
                    </div>
                    <button
                      name="submit"
                      @click="$router.push('/buy-sell')"
                      class="btn btn-success w-100 waves-effect"
                    >
                      Exchange Now
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="market section-padding page-section" data-scroll-index="1">
      <div class="container">
        <div class="row py-lg-5 justify-content-center">
          <div class="col-xl-6">
            <div class="section_heading">
              <span>Explore</span>
              <h3>The World's Leading Cryptocurrency Exchange</h3>
              <p>
                Trade Bitcoin, ETH, and hundreds of other cryptocurrencies in
                minutes.
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-12">
            <div class="card">
              <div class="card-body">
                <div class="market-table">
                  <div class="table-responsive">
                    <table class="table mb-0 table-responsive-sm">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Price</th>
                          <th>Change</th>
                          <th>Chart</th>
                          <th>Trade</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td class="coin_icon">
                            <i class="cc BTC"></i>
                            <span>Bitcoin <b>BTC</b></span>
                          </td>

                          <td>USD 680,175.06</td>
                          <td>
                            <span class="text-success">+1.13%</span>
                          </td>
                          <td>
                            <span class="sparkline8"
                              ><canvas
                                width="200"
                                height="25"
                                style="
                                  display: inline-block;
                                  width: 200px;
                                  height: 25px;
                                  vertical-align: top;
                                "
                              ></canvas
                            ></span>
                          </td>
                          <td>
                            <a href="#" class="btn btn-success waves-effect"
                              >Buy</a
                            >
                          </td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td class="coin_icon">
                            <i class="cc ETH"></i>
                            <span>Ethereum <b>ETH</b></span>
                          </td>

                          <td>USD 680,175.06</td>
                          <td>
                            <span class="text-success">+1.13%</span>
                          </td>
                          <td>
                            <span class="sparkline8"
                              ><canvas
                                width="200"
                                height="25"
                                style="
                                  display: inline-block;
                                  width: 200px;
                                  height: 25px;
                                  vertical-align: top;
                                "
                              ></canvas
                            ></span>
                          </td>
                          <td>
                            <a href="#" class="btn btn-success waves-effect"
                              >Buy</a
                            >
                          </td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td class="coin_icon">
                            <i class="cc BCH-alt"></i>
                            <span>Bitcoin Cash <b>BCH</b></span>
                          </td>

                          <td>USD 680,175.06</td>
                          <td>
                            <span class="text-success">+1.13%</span>
                          </td>
                          <td>
                            <span class="sparkline8"
                              ><canvas
                                width="200"
                                height="25"
                                style="
                                  display: inline-block;
                                  width: 200px;
                                  height: 25px;
                                  vertical-align: top;
                                "
                              ></canvas
                            ></span>
                          </td>
                          <td>
                            <a href="#" class="btn btn-success waves-effect"
                              >Buy</a
                            >
                          </td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td class="coin_icon">
                            <i class="cc LTC"></i>
                            <span>Litecoin <b>LTC</b></span>
                          </td>

                          <td>USD 680,175.06</td>
                          <td>
                            <span class="text-danger">-0.47%</span>
                          </td>
                          <td>
                            <span class="sparkline8"
                              ><canvas
                                width="200"
                                height="25"
                                style="
                                  display: inline-block;
                                  width: 200px;
                                  height: 25px;
                                  vertical-align: top;
                                "
                              ></canvas
                            ></span>
                          </td>
                          <td>
                            <a href="#" class="btn btn-success waves-effect"
                              >Buy</a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="features section-padding">
      <div class="container">
        <div class="row py-lg-5 justify-content-center">
          <div class="col-xl-6">
            <div class="section_heading">
              <span>Features</span>
              <h3>The most trusted cryptocurrency platform</h3>
              <p>Here are a few reasons why you should choose OTC919</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="features-content">
              <span><i class="fa fa-shield"></i></span>
              <h4>Secure storage</h4>
              <p>
                We store the vast majority of the digital assets in secure
                offline storage.
              </p>
              <a href="#">Learn more <i class="la la-angle-right"></i></a>
            </div>
          </div>
          <div class="col-md-4">
            <div class="features-content">
              <span><i class="fa fa-cubes"></i></span>
              <h4>Protected by insurance</h4>
              <p>
                Cryptocurrency stored on our servers is covered by our insurance
                policy.
              </p>
              <a href="#">Learn more <i class="la la-angle-right"></i></a>
            </div>
          </div>
          <div class="col-md-4">
            <div class="features-content">
              <span><i class="fa fa-life-ring"></i></span>
              <h4>Industry best practices</h4>
              <p>
                Tradientsupports a variety of the most popular digital
                currencies.
              </p>
              <a href="#">Learn more <i class="la la-angle-right"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="portfolio section-padding" data-scroll-index="2">
      <div class="container">
        <div class="row py-lg-5 justify-content-center">
          <div class="col-xl-6">
            <div class="section_heading">
              <span>Join Us</span>
              <h3>Create your cryptocurrency portfolio today</h3>
              <p>
                Tradient has a variety of features that make it the best place
                to start trading
              </p>
            </div>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-xl-5 col-md-6">
            <div class="portfolio_list">
              <div class="d-flex">
                <span class="port-icon"> <i class="la la-bar-chart"></i></span>
                <div class="flex-grow-1">
                  <h4>Manage your portfolio</h4>
                  <p>
                    Buy and sell popular digital currencies, keep track of them
                    in the one place.
                  </p>
                </div>
              </div>
              <div class="d-flex">
                <span class="port-icon">
                  <i class="la la-calendar-check-o"></i
                ></span>
                <div class="flex-grow-1">
                  <h4>Recurring buys</h4>
                  <p>
                    Invest in cryptocurrency slowly over time by scheduling buys
                    daily, weekly, or monthly.
                  </p>
                </div>
              </div>
              <div class="d-flex">
                <span class="port-icon"> <i class="la la-lock"></i></span>
                <div class="flex-grow-1">
                  <h4>Vault protection</h4>
                  <p>
                    For added security, store your funds in a vault with time
                    delayed withdrawals.
                  </p>
                </div>
              </div>
              <div class="d-flex">
                <span class="port-icon"> <i class="la la-android"></i></span>
                <div class="flex-grow-1">
                  <h4>Mobile apps</h4>
                  <p>
                    Stay on top of the markets with the Tradient app for
                    <a href="#">Android</a> or <a href="#">iOS</a>.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-7 col-md-6">
            <div class="portfolio_img">
              <img
                src="images/portfolio.png"
                tppabs="https://tradient-html.vercel.app/images/portfolio.png"
                alt=""
                class="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="testimonial section-padding" data-scroll-index="3">
      <div class="container">
        <div class="row py-lg-5 justify-content-center">
          <div class="col-xl-6">
            <div class="section_heading">
              <span>What's Say</span>
              <h3>Trusted by 2 million customers</h3>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-xl-8 col-md-11">
            <div class="testimonial-content">
              <div class="owl-carousel owl-theme owl-loaded owl-drag">
                <div class="owl-stage-outer">
                  <div
                    class="owl-stage"
                    style="
                      transform: translate3d(-1560px, 0px, 0px);
                      transition: all 0s ease 0s;
                      width: 4681px;
                    "
                  >
                    <div
                      class="owl-item cloned"
                      style="width: 770.062px; margin-right: 10px"
                    >
                      <div class="row align-items-center">
                        <div class="col-xl-6 col-md-6">
                          <div class="customer-img">
                            <img
                              class="img-fluid"
                              src="images/testimonial/1.jpg"
                              tppabs="https://tradient-html.vercel.app/images/testimonial/1.jpg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="col-xl-6 col-md-6">
                          <div class="customer-review">
                            <img
                              class="img-fluid"
                              src="images/brand/2.webp"
                              tppabs="https://tradient-html.vercel.app/images/brand/2.webp"
                              alt=""
                            />
                            <p>
                              Integrating Tradient services into Trezor Wallet's
                              exchange has been a great success for all parties,
                              especially the users.
                            </p>
                            <div class="customer-info">
                              <h5>Mr John Doe</h5>
                              <p>CEO, Example Company</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="owl-item cloned"
                      style="width: 770.062px; margin-right: 10px"
                    >
                      <div class="row align-items-center">
                        <div class="col-xl-6 col-md-6">
                          <div class="customer-img">
                            <img
                              class="img-fluid"
                              src="images/testimonial/2.jpg"
                              tppabs="https://tradient-html.vercel.app/images/testimonial/2.jpg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="col-xl-6 col-md-6">
                          <div class="customer-review">
                            <img
                              class="img-fluid"
                              src="images/brand/3.webp"
                              tppabs="https://tradient-html.vercel.app/images/brand/3.webp"
                              alt=""
                            />
                            <p>
                              MEW is excited to bring Tradient’s extensive range
                              of crypto assets, competitive rates and seamless
                              swap functionality
                            </p>
                            <div class="customer-info">
                              <h5>Mr Abraham</h5>
                              <p>CEO, Example Company</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="owl-item active"
                      style="width: 770.062px; margin-right: 10px"
                    >
                      <div class="row align-items-center">
                        <div class="col-xl-6 col-md-6">
                          <div class="customer-img">
                            <img
                              class="img-fluid"
                              src="images/testimonial/1.jpg"
                              tppabs="https://tradient-html.vercel.app/images/testimonial/1.jpg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="col-xl-6 col-md-6">
                          <div class="customer-review">
                            <img
                              class="img-fluid"
                              src="images/brand/2.webp"
                              tppabs="https://tradient-html.vercel.app/images/brand/2.webp"
                              alt=""
                            />
                            <p>
                              Integrating Tradient services into Trezor Wallet's
                              exchange has been a great success for all parties,
                              especially the users.
                            </p>
                            <div class="customer-info">
                              <h5>Mr John Doe</h5>
                              <p>CEO, Example Company</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="owl-item"
                      style="width: 770.062px; margin-right: 10px"
                    >
                      <div class="row align-items-center">
                        <div class="col-xl-6 col-md-6">
                          <div class="customer-img">
                            <img
                              class="img-fluid"
                              src="images/testimonial/2.jpg"
                              tppabs="https://tradient-html.vercel.app/images/testimonial/2.jpg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="col-xl-6 col-md-6">
                          <div class="customer-review">
                            <img
                              class="img-fluid"
                              src="images/brand/3.webp"
                              tppabs="https://tradient-html.vercel.app/images/brand/3.webp"
                              alt=""
                            />
                            <p>
                              MEW is excited to bring Tradient’s extensive range
                              of crypto assets, competitive rates and seamless
                              swap functionality
                            </p>
                            <div class="customer-info">
                              <h5>Mr Abraham</h5>
                              <p>CEO, Example Company</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="owl-item cloned"
                      style="width: 770.062px; margin-right: 10px"
                    >
                      <div class="row align-items-center">
                        <div class="col-xl-6 col-md-6">
                          <div class="customer-img">
                            <img
                              class="img-fluid"
                              src="images/testimonial/1.jpg"
                              tppabs="https://tradient-html.vercel.app/images/testimonial/1.jpg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="col-xl-6 col-md-6">
                          <div class="customer-review">
                            <img
                              class="img-fluid"
                              src="images/brand/2.webp"
                              tppabs="https://tradient-html.vercel.app/images/brand/2.webp"
                              alt=""
                            />
                            <p>
                              Integrating Tradient services into Trezor Wallet's
                              exchange has been a great success for all parties,
                              especially the users.
                            </p>
                            <div class="customer-info">
                              <h5>Mr John Doe</h5>
                              <p>CEO, Example Company</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="owl-item cloned"
                      style="width: 770.062px; margin-right: 10px"
                    >
                      <div class="row align-items-center">
                        <div class="col-xl-6 col-md-6">
                          <div class="customer-img">
                            <img
                              class="img-fluid"
                              src="images/testimonial/2.jpg"
                              tppabs="https://tradient-html.vercel.app/images/testimonial/2.jpg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="col-xl-6 col-md-6">
                          <div class="customer-review">
                            <img
                              class="img-fluid"
                              src="images/brand/3.webp"
                              tppabs="https://tradient-html.vercel.app/images/brand/3.webp"
                              alt=""
                            />
                            <p>
                              MEW is excited to bring Tradient’s extensive range
                              of crypto assets, competitive rates and seamless
                              swap functionality
                            </p>
                            <div class="customer-info">
                              <h5>Mr Abraham</h5>
                              <p>CEO, Example Company</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="owl-nav">
                  <button
                    type="button"
                    role="presentation"
                    class="owl-prev waves-effect"
                  >
                    <i class="la la-arrow-left"></i></button
                  ><button
                    type="button"
                    role="presentation"
                    class="owl-next waves-effect"
                  >
                    <i class="la la-arrow-right"></i>
                  </button>
                </div>
                <div class="owl-dots disabled"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="contact-form section-padding" data-scroll-index="4">
      <div class="container">
        <div class="row py-lg-5 justify-content-center">
          <div class="col-xl-6">
            <div class="section_heading">
              <span>Ask Question</span>
              <h3>Let us hear from you directly!</h3>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-4 col-md-4 col-sm-4">
            <div class="info-list">
              <h4 class="mb-3">Address</h4>
              <ul>
                <li><i class="fa fa-map-marker"></i> Tokyo, Japan</li>
                <!-- <li><i class="fa fa-phone"></i> (+880) 1243 665566</li> -->
                <li><i class="fa fa-envelope"></i> service.otc919@outlook.com</li>
              </ul>
            </div>
          </div>
          <div class="col-xl-8 col-md-8 col-sm-8">
            <form
              method="post"
              name="myform"
              class="contact_validate"
              novalidate="novalidate"
            >
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="mb-3">
                    <label for="contactName"> Full name </label>
                    <input
                      type="text"
                      class="form-control"
                      id="contactName"
                      placeholder="Full name"
                      name="firstname"
                    />
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="mb-3">
                    <label for="contactEmail"> Email </label>
                    <input
                      type="email"
                      class="form-control"
                      name="email"
                      placeholder="hello@domain.com"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="mb-3">
                    <textarea
                      class="form-control p-3"
                      name="message"
                      rows="5"
                      placeholder="Tell us what we can help you with!"
                    ></textarea>
                  </div>
                </div>
              </div>
              <button type="submit" class="btn btn-primary px-4 waves-effect">
                Send message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "../../components/dashboards/Header.vue";
import Footer from "../../components/Footer.vue";
import { enable_card_list } from "../../plugins/api/user_bank_acc";

export default {
  components: { Header, Footer },
  data() {
    return {
      active: "home",
      data: [],
    };
  },

  mounted() {
    this.getdata();
  },
  created() {},
  methods: {
    getdata() {
      enable_card_list().then((res) => {
        if (res.code == 0) {
          res.data.forEach((item) => {
            item.typeName = "Credit Card";
            item.cardName = "";
            switch (item.account_type) {
              case "mastercard":
                item.cardName = "Master";
                break;
              case "visa":
                item.cardName = "Visa";
                break;
              case "ae":
                item.cardName = "American Express";
                break;
              case "unionpay":
                item.cardName = "Union";
                item.typeName = "Debit Card";
                break;
            }
            return item;
          });
          // console.log(cardlist);
          this.data = res.data;
        }
      });
    },
  },
};
</script>
